import React from 'react'
import Loupe from "./loupe"
import Menu from './menu'


const TopMenu = (props) => {
  const url = typeof window !== 'undefined' ? window.location.href : '';
  return (
    <>
      <div className="collapse navbar-collapse" id="navbarSupportedContent">
       <Menu url={url} location={props?.location} menuName="goel-navegacio-principal" />
        <div className="form-inline my-2 my-lg-0 loupe-desktop">
          <Loupe />
        </div>
      </div>
      <div className="loupe-mobile">
        <Loupe />
      </div>
    </>
  )
}

export default TopMenu
